export default "__VITE_ASSET__P6$5tgh5__"